<ng-container *ngFor="let alert of alertService.alerts | async">
  <alert [dismissible]="!alert.dismissible && alert.dismissible !== true" [type]="alert.type" (onClose)="close(alert)">
    <h5 *ngIf="alert.title">{{ alert.title }}</h5>
    <span *ngIf="alert.message">{{ alert.message }}</span>
  </alert>
</ng-container>
